module.exports = __webpack_public_path__ + "img/programming-logo-fill-02-8fc876fce360b38b5d82db3bea5b8f44.48d4b8b8.png";